export const Constants = {
    APP_NAME: 'ppf-my',
} as  const;
